import React, { Component } from 'react';
import PropTypes from 'prop-types';
import './Modal.sass';

class Modal extends Component {
  constructor(props) {
    super(props);
    this.state = { show: props.open || false };
    this.trigger = this.trigger.bind(this);
    this.handleCloseModal = this.handleCloseModal.bind(this);
  }

  componentDidMount() {
    this.props.onLoad(this);
  }

  trigger(bool = null) {
    this.setState({ show: bool instanceof Boolean ? bool : (!this.state.show) });
  }

  handleCloseModal() {
    this.props.onClose();
    this.setState({ show: false });
  }

  render() {
    const {
      children,
      open,
      className,
      width,
      height,
      showCloseButton,
      backgroundDarkness,
      wrapperStyle,
      style
    } = this.props;
    let { show } = this.state;

    /* The open props will overwrite the show state */
    show = open === null ? show : open;

    return (
      <div
        className={`Modal ${show ? 'show' : ''}`}
        style={{ backgroundColor: `rgba(0, 0, 0, ${backgroundDarkness})`, ...wrapperStyle }}
      >
        <div className="modal-wrapper" style={{ width, height, ...style }}>
          {
            showCloseButton ?
              <button onClick={this.handleCloseModal} className="modal-close-btn" />
              : undefined
          }
          <div className={`modal-content ${className}`}>{children}</div>
        </div>
      </div>
    );
  }
}

Modal.propTypes = {
  children: PropTypes.any.isRequired,
  width: PropTypes.string,
  height: PropTypes.string,
  open: PropTypes.bool,
  className: PropTypes.string,
  showCloseButton: PropTypes.bool,
  backgroundDarkness(props, propName, componentName) {
    if (
      typeof props[propName] !== 'number' ||
      props[propName] < 0 ||
      props[propName] > 1
    ) {
      return new Error(
        `Invalid prop \`${propName}\` supplied to ${componentName} should be number between 0 ~ 1`
      );
    }
    return undefined;
  },
  wrapperStyle: PropTypes.object,
  style: PropTypes.object,
  onLoad: PropTypes.func,
  onClose: PropTypes.func
  // onOpen: PropTypes.func
};

Modal.defaultProps = {
  open: null,
  className: '',
  width: '300pt',
  height: '200pt',
  showCloseButton: true,
  backgroundDarkness: 0.3,
  wrapperStyle: {},
  style: {},
  onLoad() { },
  onClose() { }
  // onOpen() { },
};

export default Modal;



// WEBPACK FOOTER //
// ./src/components/Modal.jsx